import {RECEIVE_ATTENDANCE} from 'shared/portfolio/actions/courses';

export const attendanceReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_ATTENDANCE:
      return {
        ...state,
        ...action.attendance,
      };
    default:
      return state;
  }
};
